<template>
  <div class="appointment-confirm">
    <h3 class="appointment-title">客户信息</h3>
    <customer @change="customerChange" />

    <div
      class="appointment-title"
      v-if="form.diagnose_location === '新太' && type == keyMap.triage"
    >
      <h3>补充信息</h3>
    </div>
    <template v-if="form.diagnose_location === '新太' && type == keyMap.triage">
      <div class="appointment-infor">
        <div class="appointment-infor-date">
          <div class="appointment-infor-date-left">
            <div>
              <div>
                <span>
                  主要联系人
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="appointment-infor-date appointment-infor-date-clounm">
          <van-radio-group
            v-model="form.contacts_type"
            @change="changeDateType"
          >
            <van-radio :name="1">客户本人</van-radio>
            <van-radio :name="2">其他人</van-radio>
          </van-radio-group>
          <van-field
            v-show="form.contacts_type === 2"
            label-width="40px"
            v-model="form.contacts_name"
            label="姓名"
            placeholder="请输入主要联系人姓名"
          />
          <van-field
            v-show="form.contacts_type === 2"
            label-width="40px"
            v-model="form.contacts_phone"
            label="电话"
            placeholder="请输入主要联系人电话"
          />

        </div>
        <div class="appointment-infor-date">
          <div class="appointment-infor-date-left">
            <div>
              <div>
                <span>
                  客户国籍
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="appointment-infor-date appointment-infor-date-clounm">
          <van-radio-group
            v-model="form.contacts_country"
            @change="changeDateType"
          >
            <van-radio :name="1">中国</van-radio>
            <van-radio
              :name="2"
              class="appointment-radio-input"
            >
              外籍<van-field
                v-show="form.contacts_country === 2"
                v-model="form.contacts_language"
                maxlength="30"
                label=""
                placeholder="请输入国籍与语言"
              />
            </van-radio>
          </van-radio-group>

        </div>

      </div>
    </template>
    <div class="appointment-title">
      <h3>就诊信息</h3>
      <template v-if="mode == keyMap.appointment">
        <van-icon
          name="warning"
          class="icon"
        />
        <span>即刻预约成功</span>
      </template>
      <template v-if="type == keyMap.triage">
        <van-icon
          name="warning"
          class="icon"
        />
        <span>预计24小时内完成预约</span>
      </template>
      <template v-if="mode == keyMap.intention && doctorList.length > 0">
        <van-icon
          name="warning"
          class="icon"
        />
        <span>{{
          doctorList[0].diagnose_remind
            ? "预计4小时内完成预约"
            : "预计8小时内完成预约"
        }}</span>
      </template>
    </div>
    <template v-if="type != keyMap.triage">
      <div class="appointment-infor">
        <template v-if="doctorList.length > 0">
          <div
            v-for="doctor in doctorList"
            :key="doctor.id"
            class="appointment-doctor"
          >
            <strong> {{ doctor.department }}</strong>
            <span class="appointment-doctor-name"> {{ doctor.name }}</span>
            <span class="appointment-doctor-title">
              {{ doctor.title }}医师
            </span>
          </div>
          <h4>
            {{ doctorList[0].diagnose_remind ? "拟出诊时间" : "无拟出诊时间" }}
          </h4>
          <span style="color: red">{{ doctorList[0].diagnose_remind }}</span>
        </template>
      </div>
    </template>
    <template v-if="form.diagnose_location === '新太' && type == keyMap.triage">
      <div class="appointment-infor">

        <div class="appointment-infor-date">
          <div class="appointment-infor-date-left">
            <div>
              <div>
                <span>
                  客户需求选填（均需自费）
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="appointment-infor-date appointment-infor-date-clounm">
          <!-- <van-checkbox-group v-model="form.result"> -->
          <van-checkbox
            name="expert_check"
            shape="square"
            v-model="form.expert_check"
          >
            <span class="appointment-checkbox-lable">
              专家看诊
            </span>
            <van-field
              v-show="form.expert_check"
              v-model="form.expert_content"
              label=""
              placeholder="是否指定专家"
              @click.stop
            />
            <div
              class="appointment-button-text"
              @click.stop="showDetail('zhuanjiazhenfei')"
            >
              查看详情
            </div>
          </van-checkbox>
          <van-checkbox
            name="mdt_check"
            shape="square"
            v-model="form.mdt_check"
          >
            <span class="appointment-checkbox-lable">
              MDT
            </span>
            <van-field
              v-show="form.mdt_check"
              v-model="form.mdt_content"
              label=""
              placeholder="用意可明示"
              @click.stop
            />
            <div
              class="appointment-button-text"
              @click.stop="showDetail('mdt_huizhen')"
            >
              查看详情
            </div>
          </van-checkbox>
          <van-checkbox
            name="referral_check"
            shape="square"
            v-model="form.referral_check"
          >
            <span class="appointment-checkbox-lable">
              转诊一体化
            </span>
            <van-field
              v-show="form.referral_check"
              v-model="form.referral_content"
              label=""
              placeholder="是否指定医院"
              @click.stop
            />
            <div
              class="appointment-button-text"
              @click.stop="showDetail('duoxuekezhuanzhen')"
            >
              查看详情
            </div>
          </van-checkbox>
          <!-- </van-checkbox-group> -->

        </div>
        <div class="appointment-infor-date">
          <div class="appointment-infor-date-left">
            <div>
              <div>
                <span>
                  患者看诊方式（可多选）
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="appointment-infor-date appointment-infor-date-clounm">
          <van-checkbox
            v-model="form.online_check"
            name="online_check"
            shape="square"
            style="margin-bottom: 10px;"
          >
            线上
          </van-checkbox>
          <van-checkbox
            v-model="form.offline_check"
            name="offline_check"
            shape="square"
          >
            线下
          </van-checkbox>
          <van-checkbox
            v-model="form.other_check"
            name="other_check"
            shape="square"
          >
            其他
            <van-field
              v-show="form.other_check"
              v-model="form.other_content"
              label=""
              placeholder="请输入中文"
              maxlength="100"
              @click.stop
            />

          </van-checkbox>

        </div>

      </div>
    </template>
    <div class="appointment-infor">
      <div class="appointment-infor-date">
        <div class="appointment-infor-date-left">
          <div>
            <div>
              <span>
                {{
                  mode == keyMap.appointment
                    ? "您的就诊时间"
                    : "您的期望就诊时间"
                }}
              </span>
            </div>
            <div v-if="form.booking_date">
              <strong>{{
                moment(form.booking_date).format("MM月DD日")
              }}</strong>
              {{ form.booking_stime }} - {{ form.booking_etime }}
            </div>
            <div v-if="form.booking_date">
              <span>
                {{ moment(form.booking_date).format("YYYY年") }}，{{
                  weekMap[moment(form.booking_date).day()]
                }}
              </span>
            </div>
          </div>
        </div>
        <template v-if="mode == keyMap.appointment">
          <div class="appointment-infor-date-right">
            <el-button
              type="primary"
              size="mini"
              @click="calendarShow = true"
            >选择</el-button>
          </div>
        </template>
      </div>
      <div class="appointment-infor-date">
        <template v-if="mode !== keyMap.appointment">
          <van-radio-group
            v-model="form.diagnose_date_type"
            @change="changeDateType"
          >
            <van-radio :name="1">按照医生出诊时间</van-radio>
            <van-radio :name="2">自定义日期</van-radio>
          </van-radio-group>
        </template>
        <template v-if="dateTypeFlag">
          <el-button
            type="primary"
            size="mini"
            @click="calendarDateType = true"
          >选择</el-button>
        </template>
      </div>
      <div
        class="appointment-infor-date appointment-infor-date-clounm appointment-infor-date-noborder"
        v-if="type == keyMap.appointment && mode == keyMap.appointment || type == keyMap.triage"
      >
        <van-field
          label-width="60px"
          label="付费方式"
          placeholder=""
        >
          <template #input>
            <van-radio-group
              v-model="form.pay_method"
              direction="horizontal"
            >
              <van-radio :name="1">商保</van-radio>
              <van-radio :name="2">自费</van-radio>
            </van-radio-group>
          </template>

        </van-field>
      </div>

      <p
        v-if="form.diagnose_sdate"
        class="appointment-infor-date-p"
      >
        {{ form.diagnose_sdate }} ～ {{ form.diagnose_edate }}
      </p>
    </div>
    <div class="appointment-infor">
      <van-field
        v-model="form.disease_desc"
        rows="2"
        autosize
        label=""
        :border="true"
        type="textarea"
        maxlength="300"
        :placeholder="
          type == keyMap.triage
            ? '请填写病情描述，用药情况，意向医院、科室、医生等信息'
            : '请填写病情描述，用药情况信息'
        "
        show-word-limit
      />
      <div
        class="appointment-infor-tips"
        v-if="form.diagnose_location === '新太' && type == keyMap.triage"
      >
        <p>
          需提供资料：历次门诊、住院病历、检查报告。

        </p>
        <p>
          现病史：最新的门诊病历、入院记录、出院小结、检查报告等

        </p>
        <p>
          注：以上信息收集后工作日4小时内新太门诊部给与分诊方案反馈，感谢您的支持!

        </p>

      </div>
      <div
        class="appointment-infor-tips"
        v-else
      >
        请补充病症部位，检查报告或其他病情资料

      </div>

      <upload
        @change="fileChange"
        :type="type"
        @imageUpdate="imageUpdate"
      />
      <div
        class="appointment-infor-tips"
        v-if="type == keyMap.appointment && mode == keyMap.appointment"
      >
        <p>
          付费方式选择商保时请上传客户身份证正反面、保卡等
        </p>

      </div>

      <div
        class="appointment-infor-date"
        v-if="type == keyMap.appointment && mode == keyMap.appointment"
      >
        <div class="appointment-infor-date-left">
          <div>
            <div>
              <span>
                是否发送短信
              </span>
            </div>
          </div>
        </div>
        <div class="appointment-infor-date-right">
          <van-switch
            :active-value="1"
            :inactive-value="0"
            v-model="form.is_send_message"
            shape="square"
          />
        </div>
      </div>

      <div class="appointment-infor-address">
        <strong> 就诊地点 </strong>
      </div>
      <template v-if="clinicLocation.length === 1">
        <ul class="appointment-confirm-tabs">
          <li
            v-for="location in clinicLocation"
            :key="location"
            :data-id="location"
            class="disable"
          >
            {{ location }}
          </li>
        </ul>
      </template>
      <ul
        v-else
        class="appointment-confirm-tabs"
        @click="changeLocation"
      >
        <li
          v-for="location in clinicLocation"
          :key="location"
          :data-id="location"
          :class="form.diagnose_location === location ? 'active' : ''"
        >
          {{ location }}
        </li>
      </ul>
    </div>
    <div class="appointment-confirm-btn">
      <el-button
        :loading="sureLoading"
        type="primary"
        @click="submit"
      >
        {{
          type == keyMap.triage
            ? "提交分诊"
            : mode == keyMap.intention
            ? "提交预约意向"
            : "提交预约"
        }}
      </el-button>
    </div>
    <!-- 分诊/意向 时间选择 -->
    <van-calendar
      v-model="calendarDateType"
      :allowSameDay="true"
      type="range"
      :minDate="minDate"
      @confirm="onConfirm"
    />
    <!-- 预约时间选择 -->
    <van-calendar
      v-model="calendarShow"
      :formatter="formatter"
      @confirm="onCalendarConfirm"
    />
    <van-popup
      v-model="timeShow"
      position="bottom"
    >
      <div class="appointment-confirm-time">
        <div class="appointment-confirm-time-title">
          <van-icon name="clock-o" />请选择时间
        </div>
        <div class="appointment-confirm-time-list">
          <div
            class="appointment-confirm-time-item"
            v-for="(item, index) in timeList"
            :key="index"
            @click="changeTime(item)"
          >
            <div class="appointment-confirm-time-item-left">
              <strong :style="{ color: item.count === 0 || !item.dis ? '#ccc' : '' }">{{ item.begin_time }}-{{ item.end_time }}</strong>
            </div>
            <div
              class="appointment-confirm-time-item-right"
              :style="{ color: item.count === 0 || !item.dis ? '#ccc' : '' }"
            >
              可约 {{ item.count }} / 总容量{{ item.total }}
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import customer from "@/views/booking/components/customer.vue";
import upload from "./components/upload.vue";
import bookingDiagnoseService from "@/apis/bookingDiagnose/index.js";
import keyMap from "@/constants/appointment.js";
import moment from "moment";
import getUserInfo from "@/models/userInfo";
import { formatDate } from "@/utils/utils";
import { ImagePreview } from "vant";

import duoxuekezhuanzhen from "@/assets/images/duoxuekezhuanzhen.jpg";
import mdt_huizhen from "@/assets/images/mdt_huizhen.png";
import zhuanjiazhenfei from "@/assets/images/zhuanjiazhenfei.png";

export default {
  components: {
    customer,
    upload,
  },
  data() {
    return {
      keyMap,
      customerInfor: {},
      weekMap: [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ],
      form: {
        booking_date: null,
        booking_stime: "",
        booking_etime: "",
        diagnose_location: "新太",
        diagnose_date_type: 1,
        is_send_message: 1,
      },
      calendarShow: false,
      timeShow: false,
      type: 1,
      mode: 1,
      doctorList: [],
      clinicLocation: ["新永", "新太", "健康中心"],
      currentUserInfo: {},
      sureLoading: false,
      dateAllList: [],
      dateList: [],
      timeList: [],
      imageUpload: false,
      dateTypeFlag: false,
      calendarDateType: false,
      minDate: this.calculateMinDate(),
    };
  },
  async created() {
    this.type = Number(this.$route.query.type);
    this.mode = Number(this.$route.query.mode);
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
  },
  mounted() {
    this.getDoctorList();
  },
  methods: {
    moment,
    showDetail(type) {
      const imgMap = {
        duoxuekezhuanzhen,
        mdt_huizhen,
        zhuanjiazhenfei,
      };
      ImagePreview([imgMap[type]]);
    },
    fileChange(fileList) {
      this.form.fileList = fileList;
    },
    formatter(day) {
      const time = formatDate(day.date);
      if (!this.dateList.includes(time)) {
        day.type = "disabled";
      }
      return day;
    },
    imageUpdate(val) {
      this.imageUpload = val;
    },
    submit() {
      const { form, currentUserInfo, type } = this;
      const query = this.$route.query;
      // 校验booking_date是否为空
      let errMsg = "";
      if (this.mode === keyMap.appointment && !form.booking_stime) {
        errMsg = "请选择就诊时间";
      } else if (!form.disease_desc) {
        errMsg = "请填写病情描述";
      } else if (!form.his_patient_cardno) {
        errMsg = "请选择客户信息";
      } else if (this.imageUpload) {
        errMsg = "附件上传中，请稍后提交";
      } else if (
        this.form.diagnose_date_type === 2 &&
        !this.form.diagnose_sdate
      ) {
        errMsg = "请选择您的期望就诊时间";
      } else if (this.mode == 3 && this.type == keyMap.triage) {
        //       2、补充信息：增加字段：
        // 主要联系人：客户本人/其他人，必选，单选，选择其他人时需要填写姓名和电话信息，选择客户本人时不展示姓名和电话字段
        // 客户国籍：中国/外籍，单选，必选，选择外籍时出现输入框，输入框必填，提示：请输入国籍和语言，长度限定30个字。
        // 3、就诊信息：新增，患者需求填选和患者看诊方式字段
        // 患者需求选填：必选，支持多选，勾选后出现中间的输入框，输入框必填，点击“查看详情”，弹出对应的详情窗口，可滑动浏览具体收费明细。
        // 患者看诊方式：必选，支持多选，勾选其他选项后出现输入框，输入框必填，提示：请输入中文，限定100个字。
        // 4、提交分诊时校验页面所有必填字段的合法性，校验通过可提交成功。
        if (!form.contacts_type) {
          errMsg = "请选择主要联系人";
        } else if (form.contacts_type === 2 && !form.contacts_name) {
          errMsg = "请输入主要联系人姓名";
        } else if (form.contacts_type === 2 && !form.contacts_phone) {
          errMsg = "请输入主要联系人电话";
        } else if (!form.contacts_country) {
          errMsg = "请选择客户国籍";
        } else if (form.contacts_country === 2 && !form.contacts_language) {
          errMsg = "请输入国籍与语言";
        } else if (
          !form.expert_check &&
          !form.mdt_check &&
          !form.referral_check
        ) {
          errMsg = "请选择患者需求选填";
        } else if (form.expert_check && !form.expert_content) {
          errMsg = "请输入专家看诊内容";
        } else if (form.mdt_check && !form.mdt_content) {
          errMsg = "请输入mdt内容";
        } else if (form.referral_check && !form.referral_content) {
          errMsg = "请输入转诊内容";
        } else if (
          !form.online_check &&
          !form.offline_check &&
          !form.other_check
        ) {
          errMsg = "请选择患者看诊方式";
        } else if (form.other_check && !form.other_content) {
          errMsg = "请输入其他内容";
        }
      } else if (
        this.type == keyMap.appointment &&
        this.mode == keyMap.appointment &&
        !form.pay_method
      ) {
        errMsg = "请选择付费方式";
      }
      if (errMsg) {
        this.$toast(errMsg);
        return;
      }
      // 把checkbox选中的值转换为1、0
      form.expert_check = form.expert_check ? 1 : 0;
      form.mdt_check = form.mdt_check ? 1 : 0;
      form.referral_check = form.referral_check ? 1 : 0;
      form.online_check = form.online_check ? 1 : 0;
      form.offline_check = form.offline_check ? 1 : 0;
      form.other_check = form.other_check ? 1 : 0;

      // 5、点击提交分诊时校验页面所有必填字段的合法性，校验通过可提交成功。
      //       <sumary>看诊ID/summary>0 个引用|乔桂兵，6分钟前|1名作者，1项更改public int diagnose id { get; set; }
      // ///<summary>联系人类型 #1-本人 2-其他</summary>1个引用|乔桂兵，6 分钟前|1 名作者，1 项更改public int gontacts_type lget; set;}
      // ///<summary>联系人姓名</summary>1个引用|乔桂兵，6分钟前|1 名作者，1 项更改public string contacts name lget; set;}
      // ≧貝鄆汽isummary>联系人手机号suuary>1个引用|乔桂兵，6分钟前11名作者，1项更改public string contacts_phonei get;set;}
      // ///<summary>国籍 #1-中国 2-外籍</summary>1个引用|乔桂兵，6分钟前11名作者，1项更改public int contacts coumtry iget; set;}
      // <sumary>语言/summary)1个引用|乔桂兵:6分钟前|1名作者，1项更改public string contacts lamguage iget;set;
      // ///<summary>专家看诊 #0-未选中 1-选中</summary)1个引用|乔桂兵，6分钟前|1 名作者，1项更改public int expert check lget; set;}
      // ///<summary>专家看诊内容</summary>1个引用|乔桂兵，6分钟前|1名作者，1项更改public string expert content iget; set:}
      // ///<summary>1DT #0-未选中 1-选中</suumumary>1个引用|乔桂兵，6分钟前|1名作者，1 项更改public int mdt check fget; set;}
      // <summary>mdt内睿sumary>1个引用|乔桂兵，6分钟前11名作者，1项更改public string mdt content i get; set;i
      // ///<summary>转诊 #0-未选中 1-选中</summary1个引用|乔桂兵，6分钟前|1名作者，1项更改public int referral check iget; set;}
      // ///<sumary>转诊内容</summary>1个引用|乔桂兵，6分钟前|1名作者，1项更改public string referral contentォ騭邙橫糐稉暂 get;set;
      //         /<summary>1DT #0-未选中 1-选中</summary)1个引用|乔桂兵，6分钟前11名作者，1项更改public int mdt check fget; set;}
      // <summary>mdt内容summary>1个引用|乔桂兵，6分钟前|1 名作者，1项更改public string mdt content iget;set;}
      // ///<summary>转诊 #0-未选中 1-选中</summary>1个引用|乔桂兵，6分钟前11名作者，1项更改public int referral check i get; set;}
      // <summary>转诊内容</sumary>1个引用|乔桂兵，6分钟前|1名作者，1项更改public string referral content iget; set;}
      // <sumary>线上#0-未选中 1-选中</sumary)1个引用|乔桂兵，6分钟前|1 名作者，1项更改public int online check fget; set:}
      // ///<summary>线下 #0-未选中 1-选中</summary>0个引用|乔桂兵，6分钟前11名作者，1项更改Public int offline check f get; set;}
      // <sumumary>其他#0-未选中 1-选中</summary)1个引用|乔桂兵，6 分钟前|1 名作者，1项更改public int other check fget; set;}
      // <summary>其他内容/sumary>1个引用|乔桂兵，6分钟前|1名作者，1项更改public string other content iget; set;}
      const params = {
        ...form,
        submit_user_id: currentUserInfo.user_id,
        submit_user_name: currentUserInfo.user_name,
        submit_user_phone: currentUserInfo.mobile,
        booking_type: type,
        doctor_id: query.doctorId ? Number(query.doctorId) : null,
        doc_ids: form.fileList
          ? form.fileList.map((item) => item.file_id).join(",")
          : null,
        booking_mode: query.mode ? Number(query.mode) : 0,
        diagnose_date_type: this.mode === 1 ? 0 : this.form.diagnose_date_type,
        triage_xintai: {
          ...form,
        },
      };
      this.sureLoading = true;
      bookingDiagnoseService
        .bookingDiagnoseAdd(params)
        .then((res) => {
          this.sureLoading = false;
          console.log(res);
          if (res && res.Status) {
            this.$toast(res.Message);
          } else {
            this.$router.push({
              path: "/appointment/success",
              query: {
                mode: this.mode,
              },
            });
          }
        })
        .catch(() => {
          this.sureLoading = false;
        });
    },
    customerChange(customerInfo) {
      const { form } = this;
      form.his_user_level = customerInfo.level;
      form.his_user_name = customerInfo.name;
      form.his_user_mobile = customerInfo.user_mobile;
      form.his_user_sex = customerInfo.user_sex;
      form.his_id_type = customerInfo.idType;
      form.his_id_no = customerInfo.idNum;
      form.his_deposit = customerInfo.accountBalance;
      form.his_expend = customerInfo.history_consumed;
      form.his_scrm_id = customerInfo.scrm_account_id;
      form.his_scrm_name = customerInfo.scrm_account_name;
      form.his_patient_cardno = customerInfo.user_cardno;
      form.his_scrm_user_id = customerInfo.scrm_user_id;
      form.his_scrm_user_name = customerInfo.scrm_user_name;
      form.his_birthday = customerInfo.birthDay;
    },
    async getDoctorList() {
      const query = this.$route.query;
      if (!query.doctorId) return;
      const params = {
        booking_type: Number(query.type),
        doctor_ids: String(query.doctorId),
      };
      const res = await bookingDiagnoseService.doctorList(params);
      this.doctorList = res || [];
      this.clinicLocation = res[0]?.diagnose_location?.split("、") || [
        "新永",
        "新太",
        "健康中心",
      ];
      this.form.diagnose_location =
        this.clinicLocation.length > 2 ? "新太" : this.clinicLocation[0];
      if (this.mode == keyMap.appointment) {
        this.getDoctorScheduling();
      }
    },
    getDoctorScheduling() {
      const query = this.$route.query;
      if (!query.doctorId) return;
      const params = {
        doctor_id: Number(query.doctorId),
        start_date: moment().format("YYYY-MM-DD"),
        end_date: moment().add(3, "months").format("YYYY-MM-DD"),
      };
      bookingDiagnoseService.doctorScheduling(params).then((res) => {
        this.dateAllList = res;
        this.dateList = res.map((item) => item.appoint_date);
      });
    },
    onCalendarConfirm(val) {
      this.calendarShow = false;
      const date = formatDate(val);
      const da = moment().format("YYYY-MM-DD HH:mm");
      this.form.booking_date = date;
      const list = this.dateAllList.filter((item) => item.appoint_date == date);
      this.timeList = list.map((i) => {
        return {
          ...i,
          dis: moment(i.appoint_date + " " + i.begin_time).isAfter(da),
        };
      });
      this.timeShow = true;
    },
    changeTime(row) {
      if (+row.count === 0) {
        return;
      }
      if (!row.dis) {
        return;
      }
      this.form.his_plan_id = row.plan_id;
      this.form.booking_stime = row.begin_time;
      this.form.booking_etime = row.end_time;
      this.timeShow = false;
    },
    cancelTime() {
      this.timeShow = false;
    },
    changeLocation(e) {
      if (e.target.nodeName === "LI") {
        this.form.diagnose_location = e.target.dataset.id;
      }
    },
    changeDateType(val) {
      if (val == 2) {
        this.dateTypeFlag = true;
      } else {
        this.dateTypeFlag = false;
        this.form.diagnose_sdate = undefined;
        this.form.diagnose_edate = undefined;
      }
    },
    calculateMinDate() {
      const today = new Date();
      const minDate = new Date(today);
      minDate.setDate(today.getDate() + 2); // 当前日期两天后的日期
      return minDate;
    },
    onConfirm(event) {
      this.calendarDateType = false;
      this.form.diagnose_sdate = formatDate(event[0]);
      this.form.diagnose_edate = formatDate(event[1]);
    },
  },
};
</script>

<style lang="scss" scoped>
.appointment-title {
  padding: 0 10px;
  background-color: #fff;
  font-size: 16px;
  font-weight: bold;
  color: #3894ff;
  margin: 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
  h3 {
    display: inline-block;
    font-size: 16px;
    margin-right: 10px;
  }
  .icon {
    font-size: 16px;
    color: orange;
    font-weight: 800;
  }
  span {
    color: red;
    font-size: 14px;
  }
}
.appointment-infor {
  padding: 10px;
  h4 {
    font-size: 16px;
    margin: 13px 0;
  }
  .van-field {
    border: 1px solid #eee;
    border-radius: 5px;
  }
}

.appointment-doctor {
  font-size: 16px;
  &-name {
    display: inline-block;
    margin: 0 10px;
    color: #101010;
    font-weight: 400;
  }
  &-title {
    color: #888888;
    font-size: 14px;
  }
}
.appointment-infor-date-p {
  margin: 0;
}
.appointment-infor-date {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .appointment-infor-date-left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    div {
      margin: 5px 0;
    }
    strong {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-right: 10px;
    }
    span {
      font-size: 16px;
      color: #999;
      margin-right: 10px;
    }
  }
  .appointment-infor-date-right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
  }
  .van-radio {
    margin-bottom: 10px;
  }
}

.appointment-infor-address {
  margin-top: 10px;
}
.appointment-infor-tips {
  font-size: 14px;
  color: #999;
  margin-bottom: 10px;
  margin-top: 10px;
  p {
    margin: 0;
  }
}
.appointment-confirm-btn {
  margin: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-button {
    width: 200px;
  }
}
.appointment-confirm-time {
  padding: 10px;
  .appointment-confirm-time-title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
    .van-icon {
      margin-right: 10px;
    }
  }
  .appointment-confirm-time-btn {
    text-align: right;
    margin-top: 20px;
  }
  .appointment-confirm-time-time {
    text-align: center;
  }
  .appointment-confirm-time-time-left {
    border-right: 1px solid #666;
  }
  .appointment-confirm-time-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 403px;
    overflow-y: auto;
  }
  .appointment-confirm-time-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
    padding: 5px 0;
    border-bottom: 1px solid #eee;
    .appointment-confirm-time-item-left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      strong {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-right: 10px;
      }
    }
    .appointment-confirm-time-item-right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;
      color: red;
    }
  }
}
</style>
<style lang="scss">
.appointment-confirm-tabs {
  margin-top: 20px;
  display: flex;
  li {
    width: 33%;
    padding: 10px 0;
    text-align: center;
    color: #409eff;
    border: 1px #409eff solid;
    background-color: #fff;
  }
  .active {
    color: #fff;
    background-color: #409eff;
  }
  .disable {
    border: 1px #868686 solid;
    color: #868686;
    background-color: #e6e6e6;
  }
}
.appointment-confirm .appointment-infor-date-clounm {
  flex-direction: column;
  align-items: baseline;
  .van-field {
    border: none;
    padding: 5px 0;
    background: transparent;
  }
  .van-cell::after {
    border-bottom: none;
  }
  .van-cell__value {
    border: 1px solid #eee;
    padding: 0 10px;
  }
  &.appointment-infor-date-noborder .van-cell__value {
    border: none;
  }
  .van-checkbox {
    width: 100%;
    height: 30px;
  }
  .van-checkbox__label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .van-field {
      flex: 1;
      margin: 0 10px;
      padding: 0;
    }
  }
  .appointment-checkbox-lable {
    width: 80px;
  }
}
.appointment-button-text {
  color: #409eff;
  font-size: 14px;
  margin-left: 10px;
  cursor: pointer;
}
.appointment-radio-input {
  .van-radio__label {
    display: flex;
    align-items: center;
  }
  .van-field {
    flex: 1;
    margin-left: 10px;
  }
}
</style>
